import React, { useMemo } from "react";
import moment from "moment/moment";

export const useClientData = (userInfo) => {
  const childBirthday = useMemo(() => {
    if (!!userInfo) {
      const {
        children: { birthday },
      } = userInfo;
      return birthday ? moment(birthday).format("DD.MM.YYYY") : "";
    }
    return "";
  }, [userInfo]);

  const childName = useMemo(() => {
    if (!!userInfo) {
      const {
        children: { first_name, middle_name, last_name },
      } = userInfo;
      return `${first_name || ""} ${middle_name || ""} ${last_name || ""}`;
    }
    return "";
  }, [userInfo]);

  const clientName = useMemo(() => {
    if (!!userInfo) {
      const {
        children: {
          client: { first_name, middle_name, last_name },
        },
      } = userInfo;
      return `${first_name || ""} ${middle_name || ""} ${last_name || ""}`;
    }
    return "Нет информации";
  }, [userInfo]);

  const clientNumber = useMemo(
    () =>
      !!userInfo
        ? `${userInfo.children?.client?.phone || ""}`
        : "Нет информации",
    [userInfo]
  );

  return { childName, childAge: childBirthday, clientName, clientNumber };
};
